import logout from '@utils/logout'
import business from '../business'
import { MessageBox, Message } from 'element-ui'
import * as code from '@/constant/request'
import { AccountType } from '@/constant/user'

const errorCodeList = [
  code.PARAMS_ERROR,
  code.BACK_END_ERROR,
  code.PASSWORD_ERROR,
  code.FREQUENT_REQUESTS,
  code.LOGIN_ERROR,
  code.LOGIN_ENDTIME,
  code.LOGIN_STOP,
  code.LOGIN_DAYOUT,
  code.WECHAT_BINDED_ERROR,
]

const tokenErrorList = [
  code.TOKEN_EMPTY,
  code.TOKEN_NO_ACCESS,
  code.TOKEN_ERROR,
  code.TOKEN_LOGIN,
  code.TOKEN_EXPIRATION,
  code.TOKEN_SIGNATURE,
  code.TOKEN_IGNORE_REQUEST,
]

export default [
  response => {
    // console.log(response, 'res')
    if (response) {
      const res = response.data
      if (res.code === undefined) {
        return response.data
      } else {
        if (res.code === code.SUCCESS) {
          return response.data
        } else if (errorCodeList.includes(res.code)) {
          if (res.code === code.LOGIN_ENDTIME) {
            // 单独处理过期的家庭训练用户，先修改code允许登录
            if (res.data && res.data.role !== AccountType.HOSPITAL) {
              res.code = code.SUCCESS
              return response.data
            }
          }
          Message({
            message: res.message,
            type: 'warning',
          })
          return Promise.reject(res.message)
        } else {
          const doFn = business[res.code]
          doFn && doFn(res)
          return response.data
        }
      }
    } else {
      return Promise.reject()
    }
  },
  error => {
    // console.log(error, 'error')
    if (error && error.response) {
      const errRes = error.response.data
      if (tokenErrorList.includes(errRes.code)) {
        MessageBox.confirm(
          '您可能已经在其它页面退出，如需继续访问当前页面，请重新登录',
          '确定登出',
          {
            confirmButtonText: '重新登录',
            type: 'warning',
          }
        )
          .then(logout)
          .catch(logout)
      }
    }
  },
]
